export interface ProvinceInterface {
  id: number;
  name: string;
  area_sq_km: string;
  website: string;
  headquarter: string;
}

export const Provinces: ProvinceInterface[] = [
  {
    id: 1,
    name: "Koshi Province",
    area_sq_km: "25906",
    website: "https://koshi.gov.np/",
    headquarter: "Biratnagar",
  },
  {
    id: 2,
    name: "Madhesh Province",
    area_sq_km: "9661",
    website: "https://madhesh.gov.np/",
    headquarter: "Janakpur",
  },
  {
    id: 3,
    name: "Bagmati Province",
    area_sq_km: "20300",
    website: "https://ocmcm.bagamati.gov.np/",
    headquarter: "Hetauda",
  },
  {
    id: 4,
    name: "Gandaki Province",
    area_sq_km: "21856",
    website: "https://gandaki.gov.np/",
    headquarter: "Pokhara",
  },
  {
    id: 5,
    name: "Lumbini Province",
    area_sq_km: "19707",
    website: "https://ocmcm.lumbini.gov.np/",
    headquarter: "Deukhuri",
  },
  {
    id: 6,
    name: "Karnali Province",
    area_sq_km: "30213",
    website: "https://karnali.gov.np/",
    headquarter: "Birendranagar",
  },
  {
    id: 7,
    name: "Sudurpaschim Province",
    area_sq_km: "19539",
    website: "https://sudurpashchim.gov.np/",
    headquarter: "Godawari",
  },
];
